import React from "react";
import { useNavigate } from "react-router-dom";
import { useLogoutCleanup } from "../hooks/useLogoutCleanup";

const Logout = () => {
  const navigate = useNavigate();
  const { performLogoutCleanup } = useLogoutCleanup();

  const handleLogout = async () => {
    const redirectPath = await performLogoutCleanup({
      hardRefresh: true,
      redirectPath: "/login",
    });
    if (redirectPath) {
      navigate(redirectPath);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="bg-white p-6 rounded shadow-md text-center max-w-sm w-full">
        <h2 className="text-xl font-semibold mb-4 text-gray-800">
          Are you sure you want to logout?
        </h2>
        <div className="flex justify-center gap-4">
          <button
            onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Yes Logout
          </button>
          <button
            onClick={() => navigate("/")}
            className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Logout;
